const STANDARD_WHITE_1 = {
  url: 'https://res.insta360.com/static/10f29f7fd54d4a88c0eb5f531966dd7f/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@2x.jpg',
  urlL: 'https://res.insta360.com/static/772baa7bba4543d1a490789715cf10fc/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@3x.jpg',
  url_m:
    'https://res.insta360.com/static/10f29f7fd54d4a88c0eb5f531966dd7f/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@2x.jpg',
  url_s:
    'https://res.insta360.com/static/11ca128118ead6b37914aafb610fc263/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD.jpg',
};
const STANDARD_BLACK_1 = {
  url: 'https://res.insta360.com/static/bcc180061c75df805414a5259faf87e4/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/7fda684ff7ee465e227c9b0c6b4623a0/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@3x.jpg',
  url_m:
    'https://res.insta360.com/static/bcc180061c75df805414a5259faf87e4/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@2x.jpg',
  url_s:
    'https://res.insta360.com/static/7b3b42644638876ec772535fb0e4d140/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91.jpg',
};
const STANDARD_2 = {
  url: 'https://res.insta360.com/static/f4383c54d2c33365f9f1fb89bdae9fb4/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@2x.jpg',
  urlL: 'https://res.insta360.com/static/1937dc22467c7849977ca15863e592ac/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@3x.jpg',
  url_m:
    'https://res.insta360.com/static/f4383c54d2c33365f9f1fb89bdae9fb4/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@2x.jpg',
  url_s: 'https://res.insta360.com/static/b622166e6ffc33541fd54a21316586e4/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002.jpg',
};
const STANDARD_3 = {
  url: 'https://res.insta360.com/static/c22cc1b8bb1dc1ffcae591e5f313fdd4/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@2x.jpg',
  urlL: 'https://res.insta360.com/static/910f7cfad7fc0571c75e1c8bb92b6074/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@3x.jpg',
  url_m:
    'https://res.insta360.com/static/c22cc1b8bb1dc1ffcae591e5f313fdd4/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@2x.jpg',
  url_s: 'https://res.insta360.com/static/02e052d45ce9ceab5b16871b8108cb50/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003.jpg',
};
const STANDARD_4 = {
  url: 'https://res.insta360.com/static/a454ef6d86edc9304e553d5454a66f66/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@2x.jpg',
  urlL: 'https://res.insta360.com/static/c637a4ccf4a27f054f8104b35a490bc2/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@3x.jpg',
  url_m:
    'https://res.insta360.com/static/a454ef6d86edc9304e553d5454a66f66/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@2x.jpg',
  url_s: 'https://res.insta360.com/static/709ebbeeca6d2765107118862cd6d321/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004.jpg',
};
const FAMILY_WHITE_1 = {
  url: 'https://res.insta360.com/static/f684b7963ea7a784d7c9f0612cb00f04/02@2x.jpg',
  urlL: 'https://res.insta360.com/static/48c629ea272d18fd281892afa473145e/02@3x.jpg',
  url_m: 'https://res.insta360.com/static/f684b7963ea7a784d7c9f0612cb00f04/02@2x.jpg',
  url_s: 'https://res.insta360.com/static/83e299066ae32080760e7b869e128ec6/02.jpg',
};
const FAMILY_BLACK_1 = {
  url: 'https://res.insta360.com/static/2b1da5f676b43540d7a5f3ce586d6427/03-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/4bae6912d19cc281f418156c064cbb08/03-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/2b1da5f676b43540d7a5f3ce586d6427/03-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/f0d6a75807ba9658b5be8855b198a440/03-%E9%BB%91.jpg',
};
const FAMILY_2 = {
  url: 'https://res.insta360.com/static/2132bc56c4d3bb95711a433c1d4f2649/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/290ca55d2053e8b0e2e6fc4e1453e572/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/2132bc56c4d3bb95711a433c1d4f2649/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/3eb0d730285ed1669847e3a502ca6ab3/04.jpg',
};
const FAMILY_3 = {
  url: 'https://res.insta360.com/static/60a46bacb66ec06bc6b4459f763a41ab/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/6f4097626ade6c586084d6cd0d006a0c/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/60a46bacb66ec06bc6b4459f763a41ab/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/71a10a5f2bec78fb2d487807cf9c5f56/05.jpg',
};
const FAMILY_4 = {
  url: 'https://res.insta360.com/static/87f533a99b61d3c44915c023dff0a085/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/58fc142f2eba41ec97dcf35b2b9f6757/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/87f533a99b61d3c44915c023dff0a085/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/1a291859ba78de00fbac2be164d5637d/01.jpg',
};
const ULTIMATE_WHITE_1 = {
  url: 'https://res.insta360.com/static/80ea34a1c9b0b794e9ad7742a2d4dc42/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/4a0e17ed9ec3f0e4fe5f2d7bbf46cb82/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/80ea34a1c9b0b794e9ad7742a2d4dc42/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/b198b2abd6219064b27a9c857deebd77/01.jpg',
};
const ULTIMATE_BLACK_1 = {
  url: 'https://res.insta360.com/static/14f6ee3a8f2f615804d46991b110dcfa/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/07fa5d44bdd824825ed56472b82f3870/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/14f6ee3a8f2f615804d46991b110dcfa/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/6362e7bd148dcd779e7836e3ecdb2b38/02-%E9%BB%91.jpg',
};
const ULTIMATE_2 = {
  url: 'https://res.insta360.com/static/3bc27a9f272e3d8d8e148141e81152e4/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/1abec70b9e14a0561728566a582a483b/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/3bc27a9f272e3d8d8e148141e81152e4/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/13dd72fbe1f49986e0728fa92beb32bb/03.jpg',
};
const ULTIMATE_3 = {
  url: 'https://res.insta360.com/static/98aad5edf3a55c0fb8fddda7c4974c62/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/6267a91d47d515b3a30bd055cf1128aa/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/98aad5edf3a55c0fb8fddda7c4974c62/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/ba9c6c75ab93bf4c289c2ea1b34aefa0/04.jpg',
};
const ULTIMATE_4 = {
  url: 'https://res.insta360.com/static/203bd6cdc3fe3230a27aa0d38440a8b0/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/3d731fe601de5388759c41573ea1ea30/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/203bd6cdc3fe3230a27aa0d38440a8b0/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/bcc209ec7770509817e513ae9f4c0e08/05.jpg',
};

const ACTION_WHITE_1 = {
  url: 'https://res.insta360.com/static/f66e1b1235d891a6893094b6c2707317/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/18e4edbd79d38dc965a90d5d52b491b7/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/f66e1b1235d891a6893094b6c2707317/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/afccf0f5b5bb9a8c81932cca5444c080/01.jpg',
};
const ACTION_BLACK_1 = {
  url: 'https://res.insta360.com/static/9ecf69890751614fa56e1a040e688e15/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/7d41c137389dea319b47ff39ad807298/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/9ecf69890751614fa56e1a040e688e15/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/02388096421ed83eaf1bb509f34d3783/02-%E9%BB%91.jpg',
};
const ACTION_2 = {
  url: 'https://res.insta360.com/static/766149ccf40be62446dfe5ddf5063706/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/4382350f1fb0bea70b1faee93253c1b7/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/766149ccf40be62446dfe5ddf5063706/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/9ba9cebe34f47e92ce9fd639ca8a35bd/03.jpg',
};
const ACTION_3 = {
  url: 'https://res.insta360.com/static/601b98f07f97b0deb94e19b1529ab148/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/0928f59cfa9c684ed4b66cd1c3087ee0/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/601b98f07f97b0deb94e19b1529ab148/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/58347ccaa524b5e51e68b684b0202f4a/04.jpg',
};

const ACTION_4 = {
  url: 'https://res.insta360.com/static/6f6ee79a3e4ec5d20f82c6f0fd645031/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/29bd9fdfa2382b8c1068ab6912d861d2/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/6f6ee79a3e4ec5d20f82c6f0fd645031/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/d07879b3c8179b95cf80023074a3bc96/05.jpg',
};
const CREATOR_WHITE_1 = {
  url: 'https://res.insta360.com/static/9f8ef841e7a3b8e00bde061847724cbf/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/a941c6c131c0df04b945cf9bbf7b771a/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/9f8ef841e7a3b8e00bde061847724cbf/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/c10bbf5c8a47b744c838b81fa1b0e3eb/01.jpg',
};
const CREATOR_BLACK_1 = {
  url: 'https://res.insta360.com/static/748a8f7eb346f7f866797d29b11822f6/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/bb5779d169ffb267f329f69ea691d4a6/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/748a8f7eb346f7f866797d29b11822f6/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/9c50a49592b552ad1643a1cb999126b1/02-%E9%BB%91.jpg',
};
const CREATOR_2 = {
  url: 'https://res.insta360.com/static/2b16814aa5fd37e99c69d630be9b7327/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/d6bc923e3d08fc6edde9e2469075dcb1/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/2b16814aa5fd37e99c69d630be9b7327/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/4ebc024ba85f345bde5c57f9f1e397c0/03.jpg',
};
const CREATOR_3 = {
  url: 'https://res.insta360.com/static/7a4dc6f413750a66a32c995744318710/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/e8f42b9ae3e8cb663ee9afadc29fdeb8/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/7a4dc6f413750a66a32c995744318710/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/2352668b4b07b4a1384380b01851092c/04.jpg',
};
const CREATOR_4 = {
  url: 'https://res.insta360.com/static/952048aa0c4afc69f1a1446910a07a66/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/826b6302b31d9d39f6f128807774746b/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/952048aa0c4afc69f1a1446910a07a66/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/1a32c4e62fe4976c1948057ac4773201/05.jpg',
};
const WATER_WHITE_1 = {
  url: 'https://res.insta360.com/static/2ddff4e533a1a734430f3e153b49c94a/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/7b5602bc27f1d377971b4928336a8fb3/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/2ddff4e533a1a734430f3e153b49c94a/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/23bcec94e7714c182f16a00aacfd7b02/01.jpg',
};
const WATER_BLACK_1 = {
  url: 'https://res.insta360.com/static/8756525f076c5eb99cd64ab34c89c50d/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/ffb9730b7c324d17e23187ff2281c245/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/8756525f076c5eb99cd64ab34c89c50d/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/cae3ed6cf20ddf011e41133ceafa93e5/02-%E9%BB%91.jpg',
};
const WATER_2 = {
  url: 'https://res.insta360.com/static/e700bd5e1bc901eb3fe0d8902c7ffbae/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/f129d3a0116a51e605cba2e63ccb09dd/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/e700bd5e1bc901eb3fe0d8902c7ffbae/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/529aca619a796aa32581b7744b108dc0/03.jpg',
};
const WATER_3 = {
  url: 'https://res.insta360.com/static/5b8df52714c848ba03157eed611b7a8f/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/a98d858b7ac940484a41ae05a69fc570/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/5b8df52714c848ba03157eed611b7a8f/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/722dfde365ad81af9154f587c8a1d502/04.jpg',
};

const resourcesMapperKR = new Map([
  [3125, [STANDARD_WHITE_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard white
  [3135, [STANDARD_WHITE_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard white
  [3120, [STANDARD_BLACK_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard black
  [3130, [STANDARD_BLACK_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard black
  [3121, [FAMILY_BLACK_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family black
  [3131, [FAMILY_BLACK_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family black
  [3126, [FAMILY_WHITE_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family white
  [3136, [FAMILY_WHITE_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family white
  [3469, [ULTIMATE_BLACK_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate black
  [3470, [ULTIMATE_BLACK_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate black
  [3471, [ULTIMATE_WHITE_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate white
  [3472, [ULTIMATE_WHITE_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate white
  [3122, [ACTION_BLACK_1, ACTION_2, ACTION_3, ACTION_4]], // action black
  [3132, [ACTION_BLACK_1, ACTION_2, ACTION_3, ACTION_4]], // action black
  [3127, [ACTION_WHITE_1, ACTION_2, ACTION_3, ACTION_4]], // action white
  [3137, [ACTION_WHITE_1, ACTION_2, ACTION_3, ACTION_4]], // action white
  [3478, [CREATOR_BLACK_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator black
  [3479, [CREATOR_BLACK_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator black
  [3480, [CREATOR_WHITE_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator white
  [3481, [CREATOR_WHITE_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator white
  [3123, [WATER_BLACK_1, WATER_2, WATER_3]], // water black
  [3133, [WATER_BLACK_1, WATER_2, WATER_3]], // water black
  [3128, [WATER_WHITE_1, WATER_2, WATER_3]], // water white
  [3138, [WATER_WHITE_1, WATER_2, WATER_3]], // water white
]);

export default resourcesMapperKR;
